import axios from 'axios';
import { HANDLE_LOGIN_ERROR, HANDLE_LOGIN_SUCCESS } from 'constants/constants';
import { LDAP_CHECK_CONNEXION, URL_API, URL_BASE, URL_FRONT } from 'utils/globalConfig';
import qs from 'qs';
import { PROFIL } from '../constants/enum';

const validAuth = (dispatch, datas) => {
    dispatch({ type: HANDLE_LOGIN_SUCCESS, payload: datas, hasError: false });

    window.localStorage.setItem('token', JSON.stringify(datas.token));
    window.localStorage.setItem('user', JSON.stringify(datas));

    document.location.href = URL_FRONT + '/accueil';
};

const cleanStorage = () => {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('profil');
};

const connect = (dispatch, data) => {
    axios({
        method: 'post',
        url: URL_API + '/utilisateur/login',
        data: qs.stringify({
            login: data.username,
            password: data.password,
        }),
    })
    .then((res) => {
        if (LDAP_CHECK_CONNEXION && res.data.id_profil !== PROFIL.CLIENT) {
            axios({
                method: 'post',
                url: URL_BASE + '/oauth/token',
                withCredentials: true,
                headers: {
                    'Authorization': 'Basic U0FORUY6VGhpc0lzTm90QVNlY3JldENoYW5nZUl0IQ==',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                },
                data: qs.stringify({ grant_type: 'password', username: data.username, password: data.password }),
            })
            .then(() => {
                validAuth(dispatch, res.data);
            })
            .catch(() => {
                dispatch({ type: HANDLE_LOGIN_ERROR, payload: 'Erreur lors de l\'authentification LDAP' });
                cleanStorage();
            });
        } else {
            validAuth(dispatch, res.data);
        }
    })
    .catch((error) => {
        dispatch({
            type: HANDLE_LOGIN_ERROR,
            payload: error?.response?.data?.message
                ? error.response.data.message
                : 'Une erreur de connexion s\'est produite, merci de réessayer plus tard',
        });
        cleanStorage();
    });
};

export function handleLogin(data) {
    return (dispatch, getState) => {
        dispatch({ type: 'FETCH_HANDLE_LOGIN' });

        // Tentative de connexion à l'application
        connect(dispatch, data);
    };
}
